
export default {
  name: 'MoleculePartner'
}
